import axios from 'axios';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

// Partner-auth clone of the AOE getContracts autosuggest, served by sjm from the
// SAME sponsoredjobdb job_feed.contract table AOE read — identical id domain by
// construction (numeric keyword = id search, text = name search). NOT
// interchangeable with ContractSAAutosuggest (adv_central ids).
const getContractsJF = ({ keyword }) => {
   return axios.get(`${ process.env.REACT_APP_MS_SPONSORED_JOB_META_SECURE }autoSuggest/getContracts?keyword=${ encodeURIComponent(keyword) }`);
};

const handleApiDataResponse = (data = []) => {
   return data.map((option = {}) => {
      return ({
         ...option,
         label: `(${ option?.id }) ${ option?.name }`,
      });
   });
};

export default withAutosuggestWrapper(
   withInputErrorMessage(
      autosuggestFactory({
         apiPromise: getContractsJF,
         handleApiDataResponse,
      }),
   ),
);
